import React from 'react';
import cn from 'classnames';
import { Link, LazyImage } from '@landing/ui';

import * as styles from './Slide.module.scss';

export default function Slide({ link, image, alt, theme = 'light' }) {
  const className = cn(styles.card, styles[theme], link && styles.interactive);
  const content = <LazyImage className={styles.img} src={image} alt={alt} />;

  if (link) {
    return (
      <Link className={className} href={link} target="_blank">
        {content}
      </Link>
    );
  }

  return <div className={className}>{content}</div>;
}
